import React from "react";

export default function SakuraDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 my-6 ${className}`} aria-hidden="true">
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent via-sakura-300 to-transparent" />
      <svg width="28" height="28" viewBox="0 0 24 24" className="text-sakura-400">
        <g fill="currentColor">
          <path d="M12 3c1.3 1.5 2 2.9 2 4.2 0 1.2-.7 1.9-2 2-1.3-.1-2-.8-2-2 0-1.3.7-2.7 2-4.2z"/>
          <path d="M21 12c-1.5 1.3-2.9 2-4.2 2-1.2 0-1.9-.7-2-2 .1-1.3.8-2 2-2 1.3 0 2.7.7 4.2 2z"/>
          <path d="M12 21c-1.3-1.5-2-2.9-2-4.2 0-1.2.7-1.9 2-2 1.3.1 2 .8 2 2 0 1.3-.7 2.7-2 4.2z"/>
          <path d="M3 12c1.5-1.3 2.9-2 4.2-2 1.2 0 1.9.7 2 2-.1 1.3-.8 2-2 2-1.3 0-2.7-.7-4.2-2z"/>
          <circle cx="12" cy="12" r="1.6" fill="#D8B26E" />
        </g>
      </svg>
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent via-sakura-300 to-transparent" />
    </div>
  );
}
